import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductAvailabilityFilterService {
  public filteredShareClasses$: BehaviorSubject<string[]> = new BehaviorSubject(
    []
  );
  public filteredCIOGroups$: BehaviorSubject<string[]> = new BehaviorSubject(
    []
  );
  public filteredAssetClasses$: BehaviorSubject<string[]> = new BehaviorSubject(
    []
  );
  public searchText$: BehaviorSubject<string> = new BehaviorSubject('');
  public showOnlyFocusFunds$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  public setFilteredShareClasses(filteredShareClasses: string[]): void {
    this.filteredShareClasses$.next(filteredShareClasses);
  }

  public setFilteredAssetClasses(filteredAssetClasses: string[]): void {
    this.filteredAssetClasses$.next(filteredAssetClasses);
  }

  public setFilteredCIOGroups(filteredCIOGroups: string[]): void {
    this.filteredCIOGroups$.next(filteredCIOGroups);
  }

  public setFilteredText(searchTerm: string): void {
    this.searchText$.next(searchTerm);
  }

  public setShowOnlyFocusFunds(isEnabled: boolean): void {
    this.showOnlyFocusFunds$.next(isEnabled);
  }
}
